import React from "react";
import CrudPage, { Badge } from "@/components/CrudPage";

export default function Workers() {
  const columns = [
    { key: "name", label: "Ime i prezime", render: (r) => <span className="font-medium">{r.name}</span> },
    { key: "active", label: "Status", render: (r) => <Badge tone={r.active === "Neaktivan" ? "muted" : "success"}>{r.active || "Aktivan"}</Badge> },
  ];
  const fields = [
    { key: "name", label: "Ime i prezime", full: true, required: true },
    { key: "active", label: "Status", type: "select", options: ["Aktivan", "Neaktivan"] },
  ];
  return (
    <CrudPage
      title="Radnici"
      subtitle="Spisak radnika koji se koriste u šihtarici i rekapitulaciji"
      endpoint="workers"
      columns={columns}
      fields={fields}
      testid="workers"
      emptyDefaults={{ active: "Aktivan" }}
    />
  );
}
